import { mapMutations } from "vuex";

export default {
  methods: {
    // v-for内でvalue に当て込むため必要
    optionValue(n) {
      return n;
    },
    // 前の画面に戻る
    backToPreviousPage() {
      // 戻り先のSPA履歴が無い場合（ネイティブ側で新規画面として開かれた場合など）は、
      // router.go(-1)では戻れないためWebViewを閉じてネイティブへ戻る
      if (window.history.state?.back == null) {
        this.callNativeMethod("ncCloseWeb");
        return;
      }
      this.$router.go(-1);
    },
    // 画像URLをCSSで背景に設定する(APIから取得した画像)
    backgroundImageFromApi(url) {
      return "background-image: url(" + url + ")";
    },
    displayBookName(bookGroup, masterBook) {
      // 購入後のチケット名表示用
      var name = masterBook.name;
      const name_prefix = getNamePrefix(bookGroup);
      if (name_prefix != null) {
        name = name_prefix + name;
      }
      return name;
    },
    displayPassName(bookGroup, pass) {
      var name = pass.name;
      const name_prefix = getNamePrefix(bookGroup);
      if (name_prefix != null) {
        name = name_prefix + name;
      }
      return name;
    },
    displaySheetName(bookGroup, sheet) {
      var name = sheet.name;
      const name_prefix = getNamePrefix(bookGroup);
      if (name_prefix != null) {
        name = name_prefix + name;
      }
      return name;
    },
    displayBookComment(bookGroup, masterBook) {
      var comment = masterBook.comment;
      const optional_comment = getOptionalComment(bookGroup);
      if (optional_comment != null) {
        comment = comment + optional_comment;
      }
      return comment;
    },
    // ファーマット化した時間表示
    displayDatetime(time) {
      return this.$moment(new Date(`${time}`)).format("YYYY.MM.DD HH:mm:ss");
    },
    displayDate(time) {
      return this.$moment(new Date(`${time}`)).format("YYYY.MM.DD");
    },
    displayDateMinus1D(time) {
      return this.$moment(new Date(`${time}`))
        .subtract(1, "d")
        .format("YYYY.MM.DD");
    },
    displayReservedLimitedAt(limitedAt) {
      return this.$moment(new Date(`${limitedAt}`)).format("HH:mm");
    },
    displayMfittDateTime(time) {
      return this.$moment(new Date(`${time}`)).format("MM/DD HH:mm");
    },
    displayMfittDetailDate(dateStr) {
      const weekDays = ["日", "月", "火", "水", "木", "金", "土"];
      const date = calcTime(dateStr, 9);
      const day = date.getDay();
      return `${dateStr.replace(/-/g, "/")}(${weekDays[day]})`;
    },
    displayMfittTime(time) {
      let hm = time.match(/.{2}/g);
      return hm[0] + ":" + hm[1];
    },
    displayMfittSeatAttribute(seat_attribute) {
      let seatAttribute = "";
      switch (seat_attribute) {
        case "1":
          seatAttribute = "一般席";
          break;
        case "2":
          seatAttribute = "前展望席";
          break;
        case "3":
          seatAttribute = "後展望席";
          break;
        case "5":
          // 実際は車椅子席
          seatAttribute = "一般席";
          break;
        case "6":
          // 実際は介護席
          seatAttribute = "一般席";
          break;
        case "9":
          // 実際は調整席
          seatAttribute = "一般席";
          break;
        default:
          seatAttribute = "サルーン";
          break;
      }

      return seatAttribute;
    },
    displaySeatExclusiveCar(cars, seats) {
      if (cars) {
        for (let car of cars) {
          if (car.is_exclusive) {
            if (seats) {
              for (let seat of seats) {
                if (seat.car_number === car.number) {
                  return car.exclusive_car_name;
                }
              }
            }
          }
        }
      }
      return null;
    },
    newlineConvert: function (value) {
      if (value === null || value === undefined) {
        return "";
      }
      // 改行コード（\r\n, \r, \n）を置換し、それでも残る文字列('[BACKSLASH]r[NL]')がある場合もあるのでそれも全置換
      var str = value
        .replace(/(\\r)*\\n/g, "<br>")
        .replace(/(?:\r\n|\r|\n)/g, "<br />")
        .replace(/\[BACKSLASH\]r\[NL\]/g, "<br>")
        .replace(/\[BACKSLASH\]/g, "<br>")
        .replace(/\[NL\]/g, "<br>");
      return str;
    },

    ...mapMutations("input/ticketing", [
      "setStoreDivisions",
      "setStoreStartDateOfUse",
    ]),
  },
};

// master_book_sales_corporation: nullの場合エラーになるので確認必要
const getNamePrefix = (bookGroup) => {
  return bookGroup.master_book_sales_corporation != null
    ? bookGroup.master_book_sales_corporation.name_prefix
    : null;
};

const getOptionalComment = (bookGroup) => {
  return bookGroup.master_book_sales_corporation != null
    ? bookGroup.master_book_sales_corporation.optional_comment
    : null;
};

const calcTime = (time, offset) => {
  const dateTime = new Date(time);
  let utc = dateTime.getTime() + dateTime.getTimezoneOffset() * 60000;
  let result = new Date(utc + 3600000 * offset);
  return result;
};
